import React from "react";
import {BarChart, MapChart, Table} from "../chart";
import {Filters} from "./shared/Filters/Filters";
import {useFetchData} from "./shared/useFetchData";

const MiejscaPamieciDashboard = () => {
    const [initData, data, filters, activeFilters, setFilters] = useFetchData('MIEJSCA_PAMIECI', true);

    return (
        <div className="container">
            <div className="title-container">
                <h2 className={'title'}>Miejsca pamięci narodowej</h2>
            </div>
            <Filters data={filters} setFilters={setFilters}/>
            <div className="visualization-container">
                <Table data={data}
                       columns={['recordNumber', 'status', 'organization', 'typeOfObject']}
                       filters={filters}
                       columnNames={{
                           'recordNumber': 'Numer ewidencyjny',
                           'fullName': 'Pełna nazwa',
                       }}/>
                <BarChart data={data} title={'Status'}
                          mainKey={'organization'}
                          groupBy={'status'} value={'value'}/>
            </div>
            <div className="visualization-container">
                <MapChart data={initData}
                          filters={filters}
                          activeFilters={activeFilters}
                          groupBy={'organization'}
                          value={'value'}
                          featureClick={setFilters}/>
                <BarChart data={data}
                          groupBy={'organization'}
                          value={'value'}
                          layout={'horizontal'}
                          title={'Gmina'}/>
            </div>
        </div>
    )
}

export {MiejscaPamieciDashboard as default}